import React, { useEffect, useState, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "services/supabaseClient";
import Loader from "components/shared/Loader";
import { fetchQuizzesByIds } from "services/quizzes";

const ProgressMapIserba = lazy(() =>
	import("components/progressMap/iserba/IserbaProgressMap")
);

const quizIds = [
	"085787d1-2ac2-450e-bc2b-3ce50906fb01",
	"5376a517-4255-4f40-b3ee-777b232902dd",
	"5680955c-2187-454b-8892-892a064b23c2",
	"d58b69c0-1c30-4473-a1f2-668305ef3f93",
];

const IserbaUniqRoutePage = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let isMounted = true; // avoid setting state after unmount

		const fetchQuizzes = async () => {
			const { data, error } = await fetchQuizzesByIds(quizIds);

			if (data) {
				localStorage.setItem("quizzes", JSON.stringify(data));
			}

			if (error) {
				console.error("Error fetching quizzes:", error);
				if (isMounted) setLoading(false);
				return;
			}

			const now = new Date();

			const accessibleQuiz = data.find(
				(quiz) =>
					new Date(quiz.accessible_from) <= now &&
					new Date(quiz.accessible_until) >= now
			);

			if (isMounted) {
				setLoading(false);
				if (accessibleQuiz?.id) {
					localStorage.setItem("quiz", JSON.stringify(accessibleQuiz));
					navigate(`/start/${accessibleQuiz.id}`, { replace: true });
				} else {
					localStorage.setItem("quiz", JSON.stringify(data[0]));
					navigate(`/start/${data[0].id}`, { replace: true });
				}
			}
		};

		const quizzes = JSON.parse(localStorage.getItem("quizzes") || "[]");
		if (!quizzes.length) {
			fetchQuizzes();
		} else {
			setLoading(false);
			const now = new Date();

			const accessibleQuiz = quizzes.find(
				(quiz) =>
					new Date(quiz.accessible_from) <= now &&
					new Date(quiz.accessible_until) >= now
			);

			if (isMounted) {
				setLoading(false);
				if (accessibleQuiz?.id) {
					localStorage.setItem("quiz", JSON.stringify(accessibleQuiz));
					navigate(`/start/${accessibleQuiz.id}`, { replace: true });
				} else {
					localStorage.setItem("quiz", JSON.stringify(quizzes[0]));
					navigate(`/start/${quizzes[0].id}`, { replace: true });
				}
			}
		}

		return () => {
			isMounted = false;
		};
	}, []);

	if (loading) return <Loader />;

	return (
		<Suspense fallback={<Loader />}>
			<div className="flex h-full w-full">
				<ProgressMapIserba />
			</div>
		</Suspense>
	);
};

export default IserbaUniqRoutePage;
